export default "__VITE_ASSET__DJoobuHU__"